module.exports = __webpack_public_path__ + "img/ico-notifications.55531753.svg";